import { xs_languageCode } from "..";
import { byRanking, filterByCustomizedState, formatDateWithWeekDay, getConfiguration, getDaysLabels, getDBTimestampFromDate, getRanking } from "./utils";

export function parseTimelineData(data) {
    const result = {};

    const daysDescs = getDaysLabels();

    let days = data.wks;
    const date = new Date();
    const timestamp = getDBTimestampFromDate(date);
    const conf = getConfiguration();
    
    //  const today = getLocaleTimestamp(timestamp).split(' ')[0]; NO: this function take a timestamp and rebuild it with the timezone
    //	this means that on an italy timestamp (row 20) already in UTC + 1, getLocaleTimestamp turns it in UTC + 2
    const today = timestamp.split(' ')[0];
    if (days.length > 0) {
        if (days[0].dt < today) {
            days = days.slice(1);
        } else if (days.length > 7) {
            conf.iwh ? days = [...days.slice(0, days.length - 2), ...days.slice(days.length - 1)] : days = days.slice(0, days.length -1);
        }
    }

    result.weekDays = days.map(day => {
        const sportList = {};
        day.osps && filterByCustomizedState(Object.values(day.osps)).forEach(s => {
            sportList[s.id] = {
                id: s.id,
                descrizione: s.dsl[xs_languageCode],
                ranking: getRanking(s),
                aggregata: s.ag,
                tournaments: new Set(Object.values(s.tns)),
                categories: new Set(Object.values(s.cts))
            }
        });

        // If sp is not in the sport list it means it's not open for the current system code,
        // so I set the first one from the list as the default
        let sport = null;
        if (sportList[day.sp.id] != null) {
            sport = {
                id: day.sp.id,
                descrizione: day.sp.dsl[xs_languageCode],
                ranking: getRanking(day.sp),
                aggregata: day.sp.ag,
            };
        } else {
            sport = Object.values(sportList).sort(byRanking)[0];
        }

        const date = day.dt;
        const formattedDate = formatDateWithWeekDay(date);
        const dateShort = formattedDate.dayMonthShort;
        const dateShortYear = formattedDate.dayMonthYearShort;
        const fullDesc = day.g < 8 ? daysDescs[day.g % 7] : '';

        return {
            id: day.g,
            date,
            dateShort,
            dateShortYear,
            desc: day.dsl[xs_languageCode],
            fullDesc,
            sport,
            sportList
        };
    });

    return result;
}
